import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Data } from "@angular/router";
import { ModalGalleryService } from "../../modal-gallery/modal-gallery.service";

export interface IComment {
  taskId: any;
  task: {
    taskId: number;
    photo: string[];
  };
  comment: string;
  commentCreatedDate: number | string | Data;
  commentCreateTimeStamp: number;
  photoCode: string;
  hasCreateTask: boolean | any;
  endDate: string;
  user: {
    fullName: string;
    id: number;
    login: string;
    photoUrl: string;
  };
  result: {
    message: string;
    photo: string[];
    createdOn: string;
  };
  status: "success" | "failed" | "in_progress";
}

@Component({
  selector: "ks-comment",
  templateUrl: "./comment.component.html",
  styleUrls: ["./comment.component.scss", "./comment.component-modern.scss"],
})
export class CommentComponent implements OnInit {
  @Input()
  public comment: IComment;
  @Input() user: any;

  @Output() public comparePhoto: EventEmitter<{
    url: string;
    from: "comment" | "task";
  }> = new EventEmitter();
  @Output() public longerTask: EventEmitter<IComment> = new EventEmitter();

  isTaskOpen: boolean = false;

  constructor(private modalGalleryService: ModalGalleryService) {}

  ngOnInit() {
    // console.log("comen, userme", this.user);
  }

  openTask() {
    this.isTaskOpen = true;
  }

  closeTask() {
    this.isTaskOpen = false;
  }
  isRed(comment: IComment) {
    return comment.status == "failed";
  }
  isGreen(comment: IComment) {
    return comment.status == "success";
  }
  isYellow(comment: IComment) {
    return comment.status == "in_progress";
  }
  getTitle(comment: IComment) {
    if (!comment.status) return null;
    if (comment.status == "failed") return "Не выполнено";
    if (comment.status == "in_progress") return "В работе";
    if (comment.status == "success") return "Выполнено";
  }

  longTask(comment: IComment) {
    this.longerTask.emit(comment);
  }
  onCompareClick(url: { url: string; from: "comment" | "task" }) {
    if (url.from === "comment") {
      this.modalGalleryService.setCommentPhotoUrl(url.url);
    } else {
      this.comparePhoto.emit(url);
    }
  }
}
